/* tslint:disable */
/* eslint-disable */
import { ContactDataDisplayModel as AceXFoundPortalCoreCaqModelsContactDataDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { DataprotectionNotificationDisplayModel as AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/dataprotection-notification-display-model';
import { DocumentDisplayModel as AceXFoundPortalCoreCaqModelsDocumentDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { DocumenttypeDisplayModel as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model';
import { FinanceDataDisplayModel as AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/finance-data-display-model';
import { FragenVonAbschnittDisplayModel as AceXFoundPortalCoreCaqModelsFragenVonAbschnittDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/fragen-von-abschnitt-display-model';
import { MittelabrufDataDisplayModel as AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/mittelabruf-data-display-model';
import { PhaseDisplayModel as AceXFoundPortalCoreCaqModelsPhaseDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/phase-display-model';
import { ProjectDataDisplayModel as AceXFoundPortalCoreCaqModelsProjectDataDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { ScheduleDisplayModel as AceXFoundPortalCoreCaqModelsScheduleDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/schedule-display-model';
import { StipendiumDisplayModel as AceXFoundPortalCoreCaqModelsStipendiumDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/stipendium-display-model';
import { GlobalEnumsAcePortalstatus as AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalstatus } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-portalstatus';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode as AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-ausschreibung-ace-ausschreibung-enums-ace-ausschreibung-statuscode';
import { AceProjektAceProjektEnumsAceProjektStatuscode as AceXFoundPortalCoreEntitiesAceProjektAceProjektEnumsAceProjektStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-projekt-ace-projekt-enums-ace-projekt-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { ContactDataDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsContactDataDisplayModelFormGroup } from '@/api/model-index';
import { DataprotectionNotificationDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModelFormGroup } from '@/api/model-index';
import { DocumentDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsDocumentDisplayModelFormGroup } from '@/api/model-index';
import { DocumenttypeDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup } from '@/api/model-index';
import { FinanceDataDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsFinanceDataDisplayModelFormGroup } from '@/api/model-index';
import { FragenVonAbschnittDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsFragenVonAbschnittDisplayModelFormGroup } from '@/api/model-index';
import { MittelabrufDataDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModelFormGroup } from '@/api/model-index';
import { PhaseDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup } from '@/api/model-index';
import { ProjectDataDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsProjectDataDisplayModelFormGroup } from '@/api/model-index';
import { ScheduleDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsScheduleDisplayModelFormGroup } from '@/api/model-index';
import { StipendiumDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsStipendiumDisplayModelFormGroup } from '@/api/model-index';

export interface IProjektDisplayModel {
  attachments?: null | Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
  ausschreibungName?: null | string;
  ausschreibungsStatus?: AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode;
  contactData?: AceXFoundPortalCoreCaqModelsContactDataDisplayModel;
  dataprotection?: AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModel;
  documenttypes?: null | Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>;
  financeData?: AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel;
  finanzierungsplanDocId?: null | string;
  foerderprogrammName?: null | string;
  fragen?: null | Array<AceXFoundPortalCoreCaqModelsFragenVonAbschnittDisplayModel>;
  freigegebenZurUeberarbeitung?: null | string;
  freigegebenbis?: null | string;
  id: string;
  mittelabrufData?: AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel;
  name?: null | string;
  nummer?: null | string;
  objektTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  phase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  portalStatus?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalstatus;
  projectData?: AceXFoundPortalCoreCaqModelsProjectDataDisplayModel;
  projektStatus?: AceXFoundPortalCoreEntitiesAceProjektAceProjektEnumsAceProjektStatuscode;
  schedule?: AceXFoundPortalCoreCaqModelsScheduleDisplayModel;
  stipendium?: AceXFoundPortalCoreCaqModelsStipendiumDisplayModel;
}
export class ProjektDisplayModel extends BaseModel implements IProjektDisplayModel {
  attachments?: null | Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
  ausschreibungName?: null | string;
  ausschreibungsStatus?: AceXFoundPortalCoreEntitiesAceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode;
  contactData?: AceXFoundPortalCoreCaqModelsContactDataDisplayModel;
  dataprotection?: AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModel;
  documenttypes?: null | Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>;
  financeData?: AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel;
  finanzierungsplanDocId?: null | string;
  foerderprogrammName?: null | string;
  fragen?: null | Array<AceXFoundPortalCoreCaqModelsFragenVonAbschnittDisplayModel>;
  freigegebenZurUeberarbeitung?: null | string;
  freigegebenbis?: null | string;
  id: string;
  mittelabrufData?: AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel;
  name?: null | string;
  nummer?: null | string;
  objektTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  phase?: AceXFoundPortalCoreCaqModelsPhaseDisplayModel;
  portalStatus?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalstatus;
  projectData?: AceXFoundPortalCoreCaqModelsProjectDataDisplayModel;
  projektStatus?: AceXFoundPortalCoreEntitiesAceProjektAceProjektEnumsAceProjektStatuscode;
  schedule?: AceXFoundPortalCoreCaqModelsScheduleDisplayModel;
  stipendium?: AceXFoundPortalCoreCaqModelsStipendiumDisplayModel;
}
class BaseProjektDisplayModelFormGroup extends FormGroup {
  private static _instance: ProjektDisplayModelFormGroup;
  
  public static get Instance(): ProjektDisplayModelFormGroup {
    this._instance = new ProjektDisplayModelFormGroup({
      attachments: new FormArray([]),
      ausschreibungName: new FormControl(null),
      ausschreibungsStatus: new FormControl(null),
      contactData: AceXFoundPortalCoreCaqModelsContactDataDisplayModelFormGroup.Instance,
      dataprotection: AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModelFormGroup.Instance,
      documenttypes: new FormArray([]),
      financeData: AceXFoundPortalCoreCaqModelsFinanceDataDisplayModelFormGroup.Instance,
      finanzierungsplanDocId: new FormControl(null),
      foerderprogrammName: new FormControl(null),
      fragen: new FormArray([]),
      freigegebenZurUeberarbeitung: new FormControl(null),
      freigegebenbis: new FormControl(null),
      id: new FormControl(null, [Validators.required]),
      mittelabrufData: AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModelFormGroup.Instance,
      name: new FormControl(null),
      nummer: new FormControl(null),
      objektTyp: new FormControl(null),
      phase: AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup.Instance,
      portalStatus: new FormControl(null),
      projectData: AceXFoundPortalCoreCaqModelsProjectDataDisplayModelFormGroup.Instance,
      projektStatus: new FormControl(null),
      schedule: AceXFoundPortalCoreCaqModelsScheduleDisplayModelFormGroup.Instance,
      stipendium: AceXFoundPortalCoreCaqModelsStipendiumDisplayModelFormGroup.Instance,
    });

    return this._instance;
  }
}


export class ProjektDisplayModelFormGroup extends BaseProjektDisplayModelFormGroup {
  public get Attachments(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsDocumentDisplayModelFormGroup> {
    return this.controls["attachments"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsDocumentDisplayModelFormGroup>;
  }
  public get AusschreibungName(): FormControl {
    return this.controls["ausschreibungName"] as FormControl;
  }
  public get AusschreibungsStatus(): FormControl {
    return this.controls["ausschreibungsStatus"] as FormControl;
  }
  public get ContactData(): AceXFoundPortalCoreCaqModelsContactDataDisplayModelFormGroup {
    return this.controls["contactData"] as AceXFoundPortalCoreCaqModelsContactDataDisplayModelFormGroup;
  }
  public get Dataprotection(): AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModelFormGroup {
    return this.controls["dataprotection"] as AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModelFormGroup;
  }
  public get Documenttypes(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup> {
    return this.controls["documenttypes"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup>;
  }
  public get FinanceData(): AceXFoundPortalCoreCaqModelsFinanceDataDisplayModelFormGroup {
    return this.controls["financeData"] as AceXFoundPortalCoreCaqModelsFinanceDataDisplayModelFormGroup;
  }
  public get FinanzierungsplanDocId(): FormControl {
    return this.controls["finanzierungsplanDocId"] as FormControl;
  }
  public get FoerderprogrammName(): FormControl {
    return this.controls["foerderprogrammName"] as FormControl;
  }
  public get Fragen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFragenVonAbschnittDisplayModelFormGroup> {
    return this.controls["fragen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsFragenVonAbschnittDisplayModelFormGroup>;
  }
  public get FreigegebenZurUeberarbeitung(): FormControl {
    return this.controls["freigegebenZurUeberarbeitung"] as FormControl;
  }
  public get Freigegebenbis(): FormControl {
    return this.controls["freigegebenbis"] as FormControl;
  }
  public get Id(): FormControl {
    return this.controls["id"] as FormControl;
  }
  public get MittelabrufData(): AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModelFormGroup {
    return this.controls["mittelabrufData"] as AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModelFormGroup;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  public get Nummer(): FormControl {
    return this.controls["nummer"] as FormControl;
  }
  public get ObjektTyp(): FormControl {
    return this.controls["objektTyp"] as FormControl;
  }
  public get Phase(): AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup {
    return this.controls["phase"] as AceXFoundPortalCoreCaqModelsPhaseDisplayModelFormGroup;
  }
  public get PortalStatus(): FormControl {
    return this.controls["portalStatus"] as FormControl;
  }
  public get ProjectData(): AceXFoundPortalCoreCaqModelsProjectDataDisplayModelFormGroup {
    return this.controls["projectData"] as AceXFoundPortalCoreCaqModelsProjectDataDisplayModelFormGroup;
  }
  public get ProjektStatus(): FormControl {
    return this.controls["projektStatus"] as FormControl;
  }
  public get Schedule(): AceXFoundPortalCoreCaqModelsScheduleDisplayModelFormGroup {
    return this.controls["schedule"] as AceXFoundPortalCoreCaqModelsScheduleDisplayModelFormGroup;
  }
  public get Stipendium(): AceXFoundPortalCoreCaqModelsStipendiumDisplayModelFormGroup {
    return this.controls["stipendium"] as AceXFoundPortalCoreCaqModelsStipendiumDisplayModelFormGroup;
  }
  

}

export module ProjektDisplayModelForm
  {
    export class FormFields
    {
      static _attachments: string = "attachments";
      static _ausschreibungName: string = "ausschreibungName";
      static _ausschreibungsStatus: string = "ausschreibungsStatus";
      static _contactData: string = "contactData";
      static _dataprotection: string = "dataprotection";
      static _documenttypes: string = "documenttypes";
      static _financeData: string = "financeData";
      static _finanzierungsplanDocId: string = "finanzierungsplanDocId";
      static _foerderprogrammName: string = "foerderprogrammName";
      static _fragen: string = "fragen";
      static _freigegebenZurUeberarbeitung: string = "freigegebenZurUeberarbeitung";
      static _freigegebenbis: string = "freigegebenbis";
      static _id: string = "id";
      static _mittelabrufData: string = "mittelabrufData";
      static _name: string = "name";
      static _nummer: string = "nummer";
      static _objektTyp: string = "objektTyp";
      static _phase: string = "phase";
      static _portalStatus: string = "portalStatus";
      static _projectData: string = "projectData";
      static _projektStatus: string = "projektStatus";
      static _schedule: string = "schedule";
      static _stipendium: string = "stipendium";
    }
  }

